/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DoubleOrInfinity } from './DoubleOrInfinity';
import {
    DoubleOrInfinityFromJSON,
    DoubleOrInfinityFromJSONTyped,
    DoubleOrInfinityToJSON,
} from './DoubleOrInfinity';
import type { SingleHistogramSeriesView } from './SingleHistogramSeriesView';
import {
    SingleHistogramSeriesViewFromJSON,
    SingleHistogramSeriesViewFromJSONTyped,
    SingleHistogramSeriesViewToJSON,
} from './SingleHistogramSeriesView';

/**
 * 
 * @export
 * @interface HistogramSeriesViewResponse
 */
export interface HistogramSeriesViewResponse {
    /**
     * 
     * @type {Array<DoubleOrInfinity>}
     * @memberof HistogramSeriesViewResponse
     */
    edges: Array<DoubleOrInfinity>;
    /**
     * 
     * @type {Array<SingleHistogramSeriesView>}
     * @memberof HistogramSeriesViewResponse
     */
    elements: Array<SingleHistogramSeriesView>;
    /**
     * 
     * @type {string}
     * @memberof HistogramSeriesViewResponse
     */
    type: HistogramSeriesViewResponseTypeEnum;
}


/**
 * @export
 */
export const HistogramSeriesViewResponseTypeEnum = {
    Counting: 'COUNTING',
    Density: 'DENSITY'
} as const;
export type HistogramSeriesViewResponseTypeEnum = typeof HistogramSeriesViewResponseTypeEnum[keyof typeof HistogramSeriesViewResponseTypeEnum];


/**
 * Check if a given object implements the HistogramSeriesViewResponse interface.
 */
export function instanceOfHistogramSeriesViewResponse(value: object): value is HistogramSeriesViewResponse {
    if (!('edges' in value) || value['edges'] === undefined) return false;
    if (!('elements' in value) || value['elements'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function HistogramSeriesViewResponseFromJSON(json: any): HistogramSeriesViewResponse {
    return HistogramSeriesViewResponseFromJSONTyped(json, false);
}

export function HistogramSeriesViewResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistogramSeriesViewResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'edges': ((json['edges'] as Array<any>).map(DoubleOrInfinityFromJSON)),
        'elements': ((json['elements'] as Array<any>).map(SingleHistogramSeriesViewFromJSON)),
        'type': json['type'],
    };
}

export function HistogramSeriesViewResponseToJSON(value?: HistogramSeriesViewResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'edges': ((value['edges'] as Array<any>).map(DoubleOrInfinityToJSON)),
        'elements': ((value['elements'] as Array<any>).map(SingleHistogramSeriesViewToJSON)),
        'type': value['type'],
    };
}

